import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { PaymentPlan } from '../payments.models';
import { UiIconComponent } from '../../ui/icon/icon.component';

@Component({
  selector: 'app-plan-card',
  imports: [UiIconComponent],
  templateUrl: './plan-card.component.html',
  styleUrl: './plan-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanCardComponent {
  readonly plan = input.required<PaymentPlan>();
  readonly disabled = input(false);

  readonly selected = output<PaymentPlan>();

  /** Plan name displayed at the top of the card. */
  readonly planName = computed(() => this.plan().name ?? '');

  /** Price label with period suffix (e.g., "₹2,999 /month"). */
  readonly priceLabel = computed(() => {
    const p = this.plan();
    const period = p.price_period ? `/${p.price_period}` : '';
    return { amount: p.label, period };
  });

  /** Tokens display string from API (e.g., "100 tokens/month"). */
  readonly tokensDisplayLabel = computed(() => this.plan().tokens_display ?? '');

  /** Feature text to display in the chip. */
  readonly featureText = computed(() => (this.plan().feature_text ?? '').trim());

  /** Whether to show checkmark icon in feature chip (for carry-forward plans). */
  readonly showFeatureCheckmark = computed(() => !!this.plan().carry_over_tokens_on_expiry);

  /** Badge text displayed at top-right corner. */
  readonly badgeText = computed(() => (this.plan().badge_text ?? '').trim());

  /** Whether the badge should use highlight styling. */
  readonly isBadgeHighlighted = computed(() => this.plan().badge_variant === 'highlight');

  /** Whether feature chip should use highlighted style. */
  readonly isFeatureHighlighted = computed(() => !!this.plan().carry_over_tokens_on_expiry);

  readonly isFeatured = computed(() => !!this.plan().is_featured);

  onSelect(): void {
    if (this.disabled()) return;
    this.selected.emit(this.plan());
  }
}
